import axios from '../utils/axios';

export default function addIntegrations(adminId, integration, id, data) {
    return (
        axios.post(`/admin/${adminId}/ats-integrations/${integration}/recruiters/${id}/generate-token`,  data )
    )
}
